import { render, staticRenderFns } from "./powerText.vue?vue&type=template&id=7a8aaf68&scoped=true"
import script from "./powerText.vue?vue&type=script&lang=js"
export * from "./powerText.vue?vue&type=script&lang=js"
import style0 from "./powerText.vue?vue&type=style&index=0&id=7a8aaf68&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8aaf68",
  null
  
)

export default component.exports